import React from 'react';
import { Tooltip } from 'react-tooltip';
import useVariables from 'src/hooks/useVariables';
import { Variable } from 'src/api/types';
import { useStateSelector } from 'src/redux';
import styled from 'styled-components';
import { parseToJsx } from './util';

const Div = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 4px;
  flex-wrap: wrap;
`;

interface FormulaPreviewProps {
  value?: string | number | null;
  /** Optional pre-loaded variables (avoids a second fetch); falls back to useVariables. */
  variables?: Variable[];
  /** Reveal each variable's resolved value on hover (like the edit-form chips). */
  showValueOnHover?: boolean;
  /** When set, each resolved variable pill becomes clickable and reports its id. */
  onVariableClick?: (variableId: number) => void;
}

const FormulaPreview: React.FC<FormulaPreviewProps> = ({
  value,
  variables: variablesProp,
  showValueOnHover,
  onVariableClick,
}) => {
  const { variables: hookVariables } = useVariables({});
  const colors = useStateSelector(({ theme }) => theme.colors);
  // One tooltip per FormulaPreview instance, shared by all its chips (rendered
  // outside the flex row so it never affects layout).
  const tooltipId = React.useId();
  const variables = variablesProp ?? hookVariables ?? [];

  if (value == null || value === '') return null;

  return (
    <>
      {showValueOnHover && (
        <Tooltip id={tooltipId} style={{ backgroundColor: colors.prussianBlue, zIndex: 10, color: colors.white }} opacity={1} />
      )}
      <Div>{parseToJsx(value, variables, { showValueOnHover, tooltipId, onVariableClick })}</Div>
    </>
  );
};

export default FormulaPreview;
